import { render, staticRenderFns } from "./detailSettlement.vue?vue&type=template&id=1cc4fc7f"
import script from "./detailSettlement.vue?vue&type=script&lang=js"
export * from "./detailSettlement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports